import React, { useEffect, useState } from "react";
import totalTimg from "../../images/revenue.png";
import openTimg from "../../images/price-list.png";
import closeTimg from "../../images/box.png";
import riseTimg from "../../images/astranaut.png";
import { Bar, Pie } from "react-chartjs-2";
import { HiTicket } from "react-icons/hi2";
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement,
} from "chart.js";
import { Link, useNavigate } from "react-router-dom";
import axios from "axios";
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend,
  ArcElement
);

function ClientDashboard(props) {
  const navigate = useNavigate();
  const [tickets, setTickets] = useState([]);
  const [company, setCompany] = useState({});
  const data = {
    labels: ["Total Tickets", "Open Tickets", "Closed Tickets"],
    datasets: [
      {
        label: "Tickets",
        data: [
          closeTickets(props.clientData.id) + openTickets(props.clientData.id),
          openTickets(props.clientData.id),
          closeTickets(props.clientData.id),
        ],
        backgroundColor: ["#36a2eb", "#ff6384", "#4caf50"],
        borderRadius: 5,
      },
    ],
  };

  const options = {
    indexAxis: "y",
    responsive: true,
    maintainAspectRatio: false,
    scales: {
      x: {
        beginAtZero: true,
      },
    },
  };

  useEffect(() => {
    const getTicketsData = async () => {
      try {
        const response = await axios.get(
          `https://api.dectwinservices.com/api/tickets/${props.clientData.id}`
        );
        setTickets(response.data);
        localStorage.setItem("tickets", JSON.stringify(response.data));
      } catch (e) {
        props.handleToast({
          toastMsg:
            "Something went wrong! Please Refresh page or check internet.",
          toastColor: "#FF0000",
        });
      }
    };
    const fetchCompany = async () => {
      const myComp = await axios.get(
        `https://api.dectwinservices.com/api/user-comp/${props.clientData.assign_comp}`
      );
      if (myComp.length < 1) {
        return;
      }
      setCompany(myComp.data[0]);
    };
    fetchCompany();
    getTicketsData();
  }, [props]);

  

  function openTickets(id) {
    const filtr = tickets.filter(
      (elm) => elm.assigned_by === id && elm.status === "Open"
    );
    return filtr.length;
  }

  function closeTickets(id) {
    const filtr = tickets.filter(
      (elm) => elm.assigned_by === id && elm.status === "Closed"
    );
    return filtr.length;
  }
  return (
    <section className="px-32">
      <p className="fw-bolder fs-bigger">&nbsp;{company.company_name}</p>
      <div className="row px-2">

        <div className="col-lg-3 col-md-6 my-1">
        <div
        onClick={() => navigate('/client/tickets')}
          style={{
            background:
              "linear-gradient(90deg, rgb(255, 136, 114), rgb(255, 112, 150))",
          }}
          className="dash-container"
        >
          <h3>
            Total Tickets <br />
            <br />{" "}
            <p className="fs-bigger">
              {openTickets(props.clientData.id) +
                closeTickets(props.clientData.id)}
            </p>
          </h3>
          <img src={totalTimg} alt="Total Pic" style={{height: '6em'}}/>
        </div>
</div>

        <div className="col-lg-3 col-md-6 my-1">

        <div
        onClick={() => navigate('/client/tickets')}
          style={{
            background:
              "linear-gradient(90deg, rgb(50, 201, 193), rgb(25, 170, 203))",
          }}
          className="dash-container"
        >
          <h3>
            Open Tickets <br />
            <br />{" "}
            <p className="fs-bigger">{openTickets(props.clientData.id)}</p>
          </h3>
          <img src={openTimg} alt="Open Pic" style={{height: '6em'}}/>
          {/* <HiTicket size={100} /> */}
        </div>
</div>


        <div className="col-lg-3 col-md-6 my-1">
        <div
        onClick={() => navigate('/client/tickets')}
          style={{
            background:
              "linear-gradient(90deg, rgb(129, 112, 255), rgb(233, 114, 255))",
          }}
          className="dash-container"
        >
          <h3>
            Closed Tickets <br />
            <br />
            <p className="fs-bigger">{closeTickets(props.clientData.id)}</p>
          </h3>
          <img src={closeTimg} alt="Closed Pic" style={{height: '6em'}} />
        </div>
    </div>
    
    
    
              <div className="col-lg-3 col-md-6 my-1">
<div
        onClick={() => navigate('/client/product')}          style={{
            textDecoration: "none",
            color: "black",
            background:
              "linear-gradient(90deg, rgb(88, 160, 223), rgb(128, 132, 235))",
          }}
          className="dash-container"
        >
          <h3>
            Having Trouble <br />
            <br /> <p className="fs-bigger">Rise Ticket</p>
          </h3>
          <img src={riseTimg} alt="Total Pic" style={{height: '6em'}}/>
        </div>

        </div>

      </div>



      {/* <p style={{ margin: "16px 0" }} className="fw-bolder fs-bigger">
        &nbsp;{company.company_name}
      </p> */}
      <div className="row px-2">
<div className="col-md-4 my-2">        <div className="dash-container">
          <Bar id="chart-1" data={data} options={options} />
        </div></div>
<div className="col-md-4 my-2">        <div className="dash-container">
          <Bar id="chart-2" data={data} options={options} />
        </div></div>
<div className="col-md-4 my-2">        <div className="dash-container">
          <Pie id="chart-3" data={data} options={options} />
        </div></div>
      </div>
    </section>
  );
}

export default ClientDashboard;
